import { SelectGroupContent } from './select-group-content';
import { playerInterfaceWrapper } from '../player-interface';

export const SelectGroup = playerInterfaceWrapper(SelectGroupContent);
